import { render } from "./Projects.vue?vue&type=template&id=90c34c3e"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Projects.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90c34c3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90c34c3e', __exports__)) {
    api.reload('90c34c3e', __exports__)
  }
  
  module.hot.accept("./Projects.vue?vue&type=template&id=90c34c3e", () => {
    api.rerender('90c34c3e', render)
  })

}


export default __exports__